jQuery( document ).ready(function($) {
  $('.form-with-special-labels input:not([type="hidden"])').each(function(){
    var text_value = $(this).val();
    if(text_value != '') {
      $(this).parent().addClass('focused');
    }
  });

  $('.form-with-special-labels select').each(function(){
    var text_value = $(this).val();
    if(text_value != '0' && text_value != '') {
      $(this).parent().addClass('focused');
    }
  });

  $('.form-with-special-labels textarea').each(function(){
    var text_value = $(this).val();
    if(text_value != '') {
      $(this).parent().addClass('focused');
    }
  });

  $('.form-with-special-labels input, .form-with-special-labels textarea, .form-with-special-labels select').focus(function(){
      $(this).parent().addClass('focused');
  });

  $('.form-with-special-labels input, .form-with-special-labels textarea, .form-with-special-labels select').blur(function(){
      var inputValue = $(this).val();
      if ( inputValue == "" || inputValue == "0") {
          $(this).removeClass('filled');
          $(this).parent().removeClass('focused');
      } else {
          $(this).addClass('filled');
      }
  })
});



// WEBPACK FOOTER //
// ./private/js/season_rental/user_contact_details.js